import Layout from '@/components/feature/Layout';
import JsonLd from '@/components/base/JsonLd';
import Hero from './components/Hero';
import Feed from './components/Feed';
import Explore from './components/Explore';
import Ranking from './components/Ranking';
import Guide from './components/Guide';
import Proof, { homeFaqs } from './components/Proof';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: homeFaqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Home() {
  return (
    <Layout>
      <JsonLd data={faqSchema} />
      <Hero />
      <Feed />
      <Explore />
      <Ranking />
      <Guide />
      <Proof />
    </Layout>
  );
}